'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'refrigerator';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e026';
var svgPathData = ['M16 96l0 80 240 0 0-72c0-4.4 3.6-8 8-8s8 3.6 8 8l0 72 96 0 0-80c0-44.2-35.8-80-80-80L96 16C51.8 16 16 51.8 16 96zm0 96l0 256c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-256-96 0 0 152c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-152-240 0z', 'M288 16c44.2 0 80 35.8 80 80l0 80-96 0 0-72c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 72-240 0 0-80c0-44.2 35.8-80 80-80l192 0zM256 192l0 152c0 4.4 3.6 8 8 8s8-3.6 8-8l0-152 96 0 0 256c0 26.5-21.5 48-48 48L64 496c-26.5 0-48-21.5-48-48l0-256 240 0zM0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-53-43-96-96-96L96 0C43 0 0 43 0 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRefrigerator = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;